$(document).ready( function() {
    var current_url = location.origin;
    if (current_url.indexOf('localhost') >= 0) {
        current_url = current_url + '/namimaatti';
    }
    var animations_folder = current_url + '/wp-content/themes/namimaatti/src/assets/animations/'

    $('.qr-code-video').append('<div class="animation-container-qr-code"></div>')

    var qr_animation_containers = document.getElementsByClassName('animation-container-qr-code')
    for (var i = 0; i < qr_animation_containers.length; i++) {
        var animation = bodymovin.loadAnimation({
            container: qr_animation_containers[i],
            path: animations_folder + 'qr-code-pink.json',
            renderer: 'svg',
            loop: true,
            autoplay: true,
            name: "QR Code Animation",
        });
    }

    loadingAnimation('removing')
})

function loadingAnimation(elemClass) {

    var current_url = location.origin;
    if (current_url.indexOf('localhost') >= 0) {
        current_url = current_url + '/namimaatti';
    }

    var animations_folder = current_url + '/wp-content/themes/namimaatti/src/assets/animations/'
    var qr_animation_containers = document.getElementsByClassName(elemClass)
    for (var i = 0; i < qr_animation_containers.length; i++) {
        var animation = bodymovin.loadAnimation({
            container: qr_animation_containers[i],
            path: animations_folder + 'pinkki_loading.json',
            renderer: 'svg',
            loop: true,
            autoplay: true,
            name: "Loading Animation",
        });
    }
}

export default {
    loadingAnimation
}
  